export default '2.1.5';



// WEBPACK FOOTER //
// ./src/lib/version.js